<template>
  <div class="cookies-old">
    <!-- Legacy cookies component -->
  </div>
</template>

<script>
import md5 from "js-md5";
import { useBrand } from '@/composables/useBrand';

export default {
  name: 'CookiesOld',
  props: {
    brandSlug: String,
    lang: String,
    translations: Object
  },
  data() {
    return {
      brandConfig: null,
    };
  },
  methods: {
    getBrandText(key, fallback) {
      if (!this.brandConfig) {
        const { getBrandConfiguration } = useBrand();
        this.brandConfig = getBrandConfiguration(this.brandSlug || 'DEFAULT');
      }
      return this.brandConfig?.cookies?.[key] || fallback;
    },
    hasSpecialFeature(feature) {
      if (!this.brandConfig) {
        const { getBrandConfiguration } = useBrand();
        this.brandConfig = getBrandConfiguration(this.brandSlug || 'DEFAULT');
      }
      return this.brandConfig?.features?.[feature] || false;
    },
    getrans(string) {
      const brandId = this.brandSlug || 'DEFAULT';
      const lang = this.lang || 'en';
      var s = md5(string);
      var ss = brandId + "-" + lang.toUpperCase() + "-" + s;
      return this.translations?.[ss] || string;
    }
  },
  mounted() {
    // Initialize brand configuration
    if (this.brandSlug) {
      const { getBrandConfiguration } = useBrand();
      this.brandConfig = getBrandConfiguration(this.brandSlug);
    }
  }
}
</script>